import React, { Component } from 'react';
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact';
import AvatarEditor from 'react-avatar-editor'

import { compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';

import {setProfilePopup, toggleAddUserPopup} from '../../redux/reducers/view'
import {setProfile, updateProfileRequest} from '../../redux/reducers/updateProfile'
import {authAdminRequest, authUserRequest} from '../../redux/reducers/login'
import avatar from '../../assets/avatar.jpg';
import {
  MDBCard,
  MDBIcon,
  MDBRangeInput,
  MDBInput,
  MDBFileInput
} from "mdbreact";
import { STORAGE_LINK } from '../../constants';




class ChangeProfilePopup extends Component {
    state = {
        image: avatar,
        allowZoomOut: false,
        position: { x: 0.5, y: 0.5 },
        scale: 1,
        rotate: 0,
        borderRadius: 0,
        preview: null,
        width: 200,
        height: 140,
        bio:null
      }

      componentDidMount(){
       
        if(this.props.login.user && this.props.login.user.avatar){
          
          this.setState({image:STORAGE_LINK+this.props.login.user.avatar})
          this.setState({bio:this.props.login.user.biography})
        }
      }

      handleNewImage = e => {
        
        this.setState({ image: e[0] })
      }
    
      handleSave = data => {
        const img = this.editor.getImageScaledToCanvas().toDataURL()
        const rect = this.editor.getCroppingRect()
    
        this.setState({
          preview: {
            img,
            rect,
            scale: this.state.scale,
            width: this.state.width,
            height: this.state.height,
            borderRadius: this.state.borderRadius,
            bio: null,
            loading: false
          },
        })
      }
    
      handleScale = value => {
        const scale = parseFloat(value)
        this.setState({ scale })
      }
    
      handleAllowZoomOut = ({ target: { checked: allowZoomOut } }) => {
        this.setState({ allowZoomOut })
      }
    
      rotateLeft = e => {
        e.preventDefault()
    
        this.setState({
          rotate: this.state.rotate - 90,
        })
      }
    
      rotateRight = e => {
        e.preventDefault()
        this.setState({
          rotate: this.state.rotate + 90,
        })
      }
    
      handleBorderRadius = e => {
        const borderRadius = parseInt(e.target.value)
        this.setState({ borderRadius })
      }
    
      handleXPosition = e => {
        const x = parseFloat(e.target.value)
        this.setState({ position: { ...this.state.position, x } })
      }
    
      handleYPosition = e => {
        const y = parseFloat(e.target.value)
        this.setState({ position: { ...this.state.position, y } })
      }
    
      handleWidth = e => {
        const width = parseInt(e.target.value)
        this.setState({ width })
      }
    
      handleHeight = e => {
        const height = parseInt(e.target.value)
        this.setState({ height })
      }
    
      logCallback(e) {
        // eslint-disable-next-line
        
      }
    
      setEditorRef = editor => {
        if (editor) this.editor = editor
      }
    
      handlePositionChange = position => {
        this.setState({ position })
      }

      setBio = bio => {
        this.setState({ bio: bio })
      }
    
      handleDrop = acceptedFiles => {
        this.setState({ image: acceptedFiles[0] })
      }

      toggle = () => {
        this.props.setProfilePopup(false)
      }

      saveProfile = () => {
        const img = this.editor.getImage().toDataURL();
        let imageURL;
        
        var obj = {bio: this.state.bio, file: img}
          this.props.setProfile(obj)
          this.props.updateProfileRequest()
       
      }

      dataURLtoFile = (dataurl, filename) =>{
        let arr = dataurl.split(','),
            mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]),
            n = bstr.length,
            u8arr = new Uint8Array(n);
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n);
        }
        return new File([u8arr], filename, {type:mime});
      };

      b64toBlob = (b64Data, contentType='', sliceSize=512) => {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
      
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
      
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
      
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
      
        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
      }

      onComponentWillMount (){
        if (this.props.login.user.avatar){
          this.setState({image:STORAGE_LINK+this.props.login.user.avatar})
        }
      }
      componentWillReceiveProps (nextProps){
       if (nextProps.updateProfile.fetching){
          this.setState({loading:true})
        }else if(!this.props.updateProfile.isFetched && nextProps.updateProfile.isFetched){
          this.props.authUser();
          this.setState({loading:false})
          this.props.setProfilePopup(false)
        }
      }
  render() {
    return (
      <MDBContainer>
       
        <MDBModal isOpen={this.props.view.showProfile} toggle={this.toggle} centered>
          <MDBModalHeader toggle={this.toggle} className="default-color white-text gothamBlack m-1" style={{fontWeight:700}}>PROFILE</MDBModalHeader>
          <MDBModalBody>
            <div style={{width:'100%', textAlign:'center', borderBottom: '1px solid #DDDDDD', paddingBottom: 7, marginBottom: 10}}>
              {}
            <AvatarEditor
                ref={this.setEditorRef}
                scale={parseFloat(this.state.scale)}
                width={this.state.width}
                height={this.state.height}
                position={this.state.position}
                onPositionChange={this.handlePositionChange}
                rotate={parseFloat(this.state.rotate)}
                borderRadius={this.state.width / (100 / this.state.borderRadius)}
                onLoadFailure={this.logCallback.bind(this, 'onLoadFailed')}
                onLoadSuccess={this.logCallback.bind(this, 'onLoadSuccess')}
                onImageReady={this.logCallback.bind(this, 'onImageReady')}
                image={this.state.image}
                className="editor-canvas"
              />
          </div>
          <div style={{paddingRight:6,width:'100%', textAlign:'center', border: '1px solid #DDDDDD', marginBottom: 10}}>
            <MDBFileInput round btnColor="grey" size="sm" btnTitle="Browse" getValue={this.handleNewImage}/>
          </div>
          <div style={{clear: 'both'}}></div>
        <div style={{position:'relative'}}>
          <div style={{marginTop: 16}} className="mr-4 inline-block">Zoom:</div>
          <div  style={{width:"85%", position:'absolute', right:0, top:7}}>
          <MDBRangeInput
          min={1}
          max={2}
          value={1}
          step={0.01}
          formClassName="w-100"
          getValue={this.handleScale}
        />
          </div>
        </div>
        <div style={{clear: 'both'}}></div>
        
        <div className="pt-3">
          <div className="mr-4 inline-block">Rotate:</div>
          <div className="inline-block">
            <MDBBtn
              onClick={this.rotateLeft}
              floating
              right
              tag='a'
              size="sm"
              className='ml-auto ml-4 mt-0'
              action
            >
              <MDBIcon icon='angle-left' className="grey-color" size="sm"/>
            </MDBBtn>
            <MDBBtn
              onClick={this.rotateRight}
              floating
              right
              tag='a'
              size="sm"
              className='ml-auto ml-4 mt-0'
              action
            >
              <MDBIcon icon='angle-right' className="grey-color" size="sm"/>
            </MDBBtn>
          </div>
        </div>
        <div className="pt-3">
        <MDBInput type="textarea" label="Biography" background getValue={this.setBio} value={this.state.bio}/>
        </div>
          </MDBModalBody>
          <MDBModalFooter style={{justifyContent:'space-between'}}>
            <MDBBtn className="no-boxShadow btn-sm " color="grey" onClick={this.toggle}>Close</MDBBtn>
            <MDBBtn className="no-boxShadow btn-sm btn-dark-green" onClick={this.saveProfile}>Save changes</MDBBtn>
          </MDBModalFooter>
          {this.state.loading && <MDBCard style={{position:'absolute', top:0, left:0, right:0, bottom:0, zIndex:1070, justifyContent:'center', alignItems:'center'}}>
          <div className="spinner-grow text-primary" role="status">
        <span className="sr-only">Loading...</span>
      </div>
          </MDBCard>}
        </MDBModal>
      </MDBContainer>
    );
  }
}

const mapDispatchToProps = dispatch => ({
    toggleAddUserPopup: value => dispatch(toggleAddUserPopup(value)),
    setProfilePopup: value => dispatch(setProfilePopup(value)),
    setProfile: obj => dispatch(setProfile(obj)),
    updateProfileRequest: () => dispatch(updateProfileRequest()),
    authUser: () => dispatch(authUserRequest()),
    authAdmin: (obj) => dispatch(authAdminRequest(obj)),
  });
  
  const mapStateToProps = state => ({
    view: state.viewReducer,
    login: state.loginReducer,
    updateProfile: state.updateProfile
  });
  export default compose(
    connect(
      mapStateToProps,
      mapDispatchToProps,
    ),
    withHandlers({
      handleCloseAddUserPopup: props => () => {
        props.toggleAddUserPopup(false);
        props.toggleAddUserPopupSuccess(false);
      },
    }),
  )(ChangeProfilePopup);